

































import { Vue, Component } from "vue-property-decorator";

function formatSurchargePercent(value: string): string {
  const num = parseFloat(value);
  if (isNaN(num) || num <= 0) return "0%";
  return `${(num * 100).toFixed(0)}%`;
}

@Component
export default class PriceSurchargeModal extends Vue {
  protected surchargeValue: string = formatSurchargePercent(
    process.env.VUE_APP_PRICE_SURCHARGE_VALUE_NUMBER || ""
  );
  protected surchargeDate: string =
    process.env.VUE_APP_PRICE_SURCHARGE_DATE || "2025";
  protected closeModal(): void {
    this.$emit("close");
  }
}
